module.exports = __webpack_public_path__ + "img/ruanbao3.b42be0ea.jpg";